const GA_KEY_IN_COOKIES = '_ga';
const INDEX_FROM_WHICH_CLIENID_STARTS = 6;

export const getGaClientId = () => {
  if (typeof document == 'undefined') {
    return '';
  }

  const cookies: Record<string, string> = {};

  document.cookie.split(';').forEach((cookie) => {
    const [key, value] = cookie.split('=');
    cookies[key.trim()] = value;
  });

  return cookies[GA_KEY_IN_COOKIES]?.substring(INDEX_FROM_WHICH_CLIENID_STARTS);
};
